import React from "react";
import img1 from "../images/Custom1.png";
import img2 from "../images/Custom2.png";

const Custom = () => {
  return (
    <section className="bg-[#f7ac1c] py-12 px-4 3xl:px-20 flex flex-col 2xl:flex-row items-center justify-between">
      {/* Left Side */}
      <div className=" text-center px-20 7xl:px-28 8xl:px-32 9xl:px-36  mb-10 md:mb-0">
        <h2 className="text-4xl 3xl:text-6xl 5xl:text-7xl 8xl:text-8xl 9xl:text-[180px] font-[500]  10xl:font-[1000] text-secondary mb-4">
          <span className=" font-greatvibes font-bold ">What's</span>{" "}
          <br></br>
          <span className=" font-greatvibes ml-20 font-bold">New</span>
        </h2>
        <p className="text-lg 3xl:text-xl 8xl:text-2xl 9xl:text-3xl 10xl:text-5xl 11xl:text-6xl text-black font-medium mb-6">
          We have a custom <br /> Design Sarees
        </p>
        <button className=" text-secondary font-bold font-sans 3xl:text-lg 6xl:text-xl 7xl:text-2xl 9xl:text-3xl 11xl:text-5xl px-6 py-2 border-2 border-secondary  transition-all duration-300">
           <a
               
                href="https://www.youtube.com/watch?v=xrFsLn0Dze4"
            >
                Watch Now
            </a>
        </button>
      </div>

      {/* Right Side */}
      <div className="3xl:w-1/2 mt-4 xl:mt-6 3xl:mt-0 flex scrollbar-hide gap-6">
        <img
          src={img1}
          alt="Saree 1"
          className="w-44 3xl:w-1/2 rounded-lg shadow-lg"
        />
        <img
          src={img2}
          alt="Saree 2"
          className="w-44 3xl:w-1/2 rounded-lg shadow-lg"
        />
      </div>
    </section>
  );
};

export default Custom;
